import { Action } from "@ngrx/store";
import {Reading} from "@edp-pages/readings/components/readings-model";
import {Contract} from "@edp-components/edp-contract";

export enum EReadingActions {
    GetReadings = "Get Readings",
    SetReadings = "Set Readings",
    UploadReadingElectricity = "Upload Reading of Electricity",
    SetUploadReadingElectricity = "Set Upload Reading of Electricity",
    UploadReadingGas = "Upload Reading of Gas",
    SetUploadReadingGas = "Set Upload Reading of Gas",
}

export class GetReadings implements Action {
    public readonly type = EReadingActions.GetReadings;
    constructor(public contract: Contract, public supplyType: string, public meterId?: string) {
    }
}

export class SetReadings implements Action {
    public readonly type = EReadingActions.SetReadings;
    constructor(public readings: Reading[][]) {
    }
}

export class UploadReadingElectricity implements Action {
    public readonly type = EReadingActions.UploadReadingElectricity;
    constructor(public reading) {}
}

export class SetUploadReadingElectricity implements Action {
    public readonly type = EReadingActions.SetUploadReadingElectricity;
    constructor(public reading: boolean) {}
}
export class UploadReadingGas implements Action {
    public readonly type = EReadingActions.UploadReadingGas;
    constructor(public reading) {}
}

export class SetUploadReadingGas implements Action {
    public readonly type = EReadingActions.SetUploadReadingGas;
    constructor(public reading: boolean) {}
}

export type ReadingActions =  UploadReadingElectricity
                            | UploadReadingGas
                            | SetUploadReadingElectricity
                            | SetUploadReadingGas
                            | GetReadings
                            | SetReadings;

